"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../src/ontodia/index");
var common_1 = require("./common");
var CLASSES = require('./resources/classes.json');
var LINK_TYPES = require('./resources/linkTypes.json');
var ELEMENTS = require('./resources/elements.json');
var LINKS = require('./resources/links.json');
function onWorkspaceMounted(workspace) {
    if (!workspace) {
        return;
    }
    var diagram = common_1.tryLoadLayoutFromLocalStorage();
    workspace.getModel().importLayout({
        diagram: diagram,
        dataProvider: new index_1.DemoDataProvider(CLASSES, LINK_TYPES, ELEMENTS, LINKS),
        validateLinks: true,
    });
}
var props = {
    ref: onWorkspaceMounted,
    onSaveDiagram: function (workspace) {
        var diagram = workspace.getModel().exportLayout();
        window.location.hash = common_1.saveLayoutToLocalStorage(diagram);
        window.location.reload();
    },
    viewOptions: {
        onIriClick: function (_a) {
            var iri = _a.iri;
            return window.open(iri);
        },
    },
};
common_1.onPageLoad(function (container) { return ReactDOM.render(react_1.createElement(index_1.Workspace, props), container); });
